module.exports = __webpack_public_path__ + "media/124.3705969d.wav";